import React from 'react';
import './App.scss';
import { ChooChoo } from '@express-labs/raven-choo-choo';
import Resize from './contexts/Resize';
import HeaderV2 from './components/HeaderV2';

function App() {
  return (
    <div className="raven-header">
      <Resize>
        <ChooChoo
          mode="uid"
          value="blt3922b9222857d3b1"
          contentType="global_banner"
        />
        <HeaderV2 />
      </Resize>

    </div>
  );
}

export default App;
